module.exports = __webpack_public_path__ + "static/img/zl2.c7cf810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spec/zl2.png
// module id = Byjt
// module chunks = 73